import React from 'react';
import { connect } from 'react-redux';
import dialog from '../../apis/dialog';
import { location, projectId } from '../../apis/stringConnection';
import axios from 'axios';
//const app = require("express")();
const languageCode = 'en';


export async function detectIntentText(query, token2, sessionId, agentId) {

    let body = {
        "queryInput": {
            "text": {
                "text": query
            },
            languageCode: languageCode
        },
    };
    const t = `/v3/projects/${projectId}/locations/${location}/agents/${agentId}/sessions/${sessionId}:detectIntent`;
    //const t = '/api/breeds';
    const token = 'Bearer ' + token2;

const y =   'https://us-central1-dialogflow.googleapis.com';
    const axios = require('axios');

    const message = axios.post(y+t, body, {
        headers: {
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json;charset=utf-8',
          
            method: 'post',
            "Authorization": token
        },


    }).then(res => {
        console.log(res);
        return res.data.queryResult;
    }
    ).catch(err => {
        console.log(err);
        return err;
    })
    return message;
};

